/**
 * Clamps a `value` between a `min` and `max` value.
 * Someday this might have a native implementation as [`Math.clamp`](https://github.com/tc39/proposal-math-clamp).
 */
// ? we could probably move this to our shared utils
export default function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}
